import React, { useState, useRef, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

import SuccessModal from "./SuccessModal";
import FailedModal from "./FailedModal";
import Loading from "../SelectValue/Loading";
import postService from "../../Services/post-service";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 430,
  height: "80%",
  bgcolor: "white",
  boxShadow: 24,
  borderRadius: "16px",
  p: 4,
  maxWidth: "95%",
  outline: "none",
};

function EnterPin({
  open,
  handleClose,
  handleConfirm,
  handleCloseSidebar,
  data,
  isRenewal,
}) {
  const [pin, setPin] = useState(["", "", "", ""]);
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [loading, setLoading] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openFailed, setOpenFailed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) {
      setPin(["", "", "", ""]);
      setLoading(false);
    }
  }, [open]);

  const handleChange = (index, value) => {
    if (value.length > 1) value = value.slice(-1); // Only allow 1 char

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    // Auto focus next
    if (value && index < 3) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !pin[index] && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleConfirmLocal = () => {
    setLoading(true);
    const pinStr = pin.join("");
    
    const apiCall = isRenewal
      ? postService.renewRent(data?.id || data?.rentedApartmentClassId, data?.tenure || 1, pinStr)
      : postService.payForApartmentClass(data?.rentedApartmentClassId || data?.id, data?.tenure || 1, pinStr);
      
    apiCall
      .then((response) => {
        setLoading(false);
        if (response?.data?.statusCode === 200) {
          setOpenSuccess(true);
        } else {
          toast.error(response?.data?.decsription);
          setOpenFailed(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.description);
        setOpenFailed(true);
      });
  };

  const handleFinish = () => {
    setOpenSuccess(false);
    handleClose();
    if (handleConfirm) {
      handleConfirm();
    }
  };

  const handleViewActiveRent = () => {
    setOpenSuccess(false);
    handleClose();
    if (handleConfirm) handleConfirm();
    if (handleCloseSidebar) handleCloseSidebar();
    navigate("/rental/active");
  };

  const handleViewTransaction = () => {
    setOpenSuccess(false);
    handleClose();
    if (handleConfirm) handleConfirm();
    if (handleCloseSidebar) handleCloseSidebar();
    navigate("/wallet");
  };

  const handleTryAgain = () => {
    setOpenFailed(false);
    setPin(["", "", "", ""]);
  };

  return (
    <>
      <SuccessModal
        open={openSuccess}
        handleClose={handleFinish}
        handleViewActiveRent={handleViewActiveRent}
        handleViewTransaction={handleViewTransaction}
        data={data}
      />
      <FailedModal
        open={openFailed}
        handleClose={() => setOpenFailed(false)}
        handleTryAgain={handleTryAgain}
      />
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={{ ...style, display: "flex", flexDirection: "column" }}>
            <Loading open={loading} />
            {/* Header */}
            <div className="flex justify-end mb-4">
              <IconButton
                onClick={handleClose}
                sx={{
                  bgcolor: "#1F2937",
                  color: "white",
                  "&:hover": { bgcolor: "#374151" },
                  width: 36,
                  height: 36,
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>

            <div className="mb-8">
              <p className="font-[700] text-[20px] text-back-color2 mb-2">
                Enter your Zouse PIN
              </p>
              <p className="text-[14px] text-gray-500">
                Enter your 4-Digit PIN to confirm transaction
              </p>
            </div>

            {/* PIN Inputs */}
            <div className="flex gap-4 mb-10 justify-center">
              {pin.map((digit, index) => (
                <input
                  key={index}
                  ref={inputRefs[index]}
                  type="password"
                  autoComplete="new-password"
                  value={digit}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className={
                    `w-20 h-20 text-center text-[24px] font-[700] rounded-xl outline-none transition-colors ` +
                    (digit
                      ? "bg-[#D1F2E2] border-2 border-[#00BC67] text-back-color2"
                      : "bg-[#F9FAFB] border border-gray-100")
                  }
                  maxLength={1}
                />
              ))}
            </div>
            {/* Button */}
            <button
              onClick={handleConfirmLocal}
              className="mt-[20%] w-full bg-[#00BC67] text-white font-[700] py-4 rounded-xl transition-colors text-[18px]"
            >
              Confirm
            </button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default EnterPin;
